import React, { useState } from 'react';
import SEO from '../components/SEO';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    website: '' // Honeypot - should be empty
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    // Honeypot check - if filled, it's a bot
    if (formData.website) {
      setStatus('error');
      setTimeout(() => setStatus(''), 3000);
      return;
    }

    try {
      // Using Web3Forms for static hosting
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          access_key: '44312e23-bfcb-4e92-92bb-fb3f5de51d9e',
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          from_name: 'ART Aesthetics Website',
          replyto: formData.email,
          // Optional: Can add reCAPTCHA token here if enabled
          // recaptcha_token: await grecaptcha.executeAsync('YOUR_RECAPTCHA_SITE_KEY')
        })
      });

      const result = await response.json();
      
      if (result.success) {
        setStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '', website: '' });
        setTimeout(() => setStatus(''), 3000);
      } else {
        setStatus('error');
        setTimeout(() => setStatus(''), 3000);
      }
    } catch (error) {
      setStatus('error');
      setTimeout(() => setStatus(''), 3000);
    }
  };

  return (
    <section className="contact">
      <SEO
        title="Contact ART Aesthetics & Skincare | Widnes"
        description="Contact ART Aesthetics & Skincare in Widnes for acne support, skincare advice, and treatment enquiries."
        path="/contact"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          name: 'Contact ART Aesthetics & Skincare',
          url: 'https://artaestheticsskincare.com/contact',
          about: {
            '@type': 'MedicalBusiness',
            name: 'ART Aesthetics & Skincare'
          }
        }}
      />
      <div className="contact-container">
        <h1 className="page-title">Get In Touch</h1>
        <p className="page-subtitle">Have a question? We'd love to hear from you.</p>
        <form className="contact-form" onSubmit={handleSubmit}>
          {/* Honeypot field - hidden from users, catches bots */}
          <input
            type="text"
            name="website"
            value={formData.website}
            onChange={handleChange}
            style={{ display: 'none' }}
            tabIndex="-1"
            autoComplete="off"
          />
          
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <textarea
              name="message"
              placeholder="Your Message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-button">
            {status === 'sending' ? 'Sending...' : 'Send Message'}
          </button>
          {status === 'success' && <p className="success-message">Message sent successfully!</p>}
          {status === 'error' && <p className="error-message">Failed to send message. Please try again.</p>}
        </form>
      </div>
    </section>
  );
};

export default Contact;
